import { type ModalSize } from '../types.js';
import { Body } from './Modal.styles.js';
import { type HTMLAttributes, Ref } from 'react';

type ModalBodyProps = HTMLAttributes<HTMLDivElement> & {
  readonly desktopModalRef?: Ref<HTMLDivElement>;
  readonly noMargin?: boolean;
  readonly noMarginTop?: boolean;
  readonly size?: ModalSize;
};

const ModalBody = ({
  children,
  desktopModalRef,
  noMargin = false,
  noMarginTop = false,
  size = 'md',
  ...props
}: ModalBodyProps) => {
  return (
    <Body
      {...props}
      $size={size}
      noMargin={noMargin}
      noMarginTop={noMarginTop}
      ref={desktopModalRef}
    >
      {children}
    </Body>
  );
};

ModalBody.displayName = 'Modal.Body';

export { ModalBody };
